export enum SyncRenderEnum {
  Unlimited = 0,
  Half = 1,
  Sync = 2,
  FPS_60 = 3,
  FPS_120 = 4,
}
export const SyncRenderEnumDescriptions: Record<SyncRenderEnum, string> = {
  [SyncRenderEnum.Unlimited]: "",
  [SyncRenderEnum.Half]: "",
  [SyncRenderEnum.Sync]: "",
  [SyncRenderEnum.FPS_60]: "",
  [SyncRenderEnum.FPS_120]: "",
}
